module.exports = __webpack_public_path__ + "static/media/dash.dcbae99e.svg";